export const marketingNavigationItemsData = [
  { title: "Program", href: "/#program" },
  { title: "How It Works", href: "/#how-it-works" },
  { title: "Team", href: "/#team" },
  { title: "Vision", href: "/#vision" },
  { title: "Donate", href: "/#donate" },
];

